import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Dialog} from '../../global/util/Dialog';
import {InformType} from '../../global/util/enum/InformType';
import {TermPdfViewerComponent} from '../term-pdf-viewer/term-pdf-viewer.component';
import {TermCondition} from '../../global/util/TermCondition';
import {Constant} from '../../global/util/Constant';

@Component({
  selector: 'app-acept-terms-conditions',
  templateUrl: './accept-terms-conditions.component.html',
  styleUrls: ['./accept-terms-conditions.component.css']
})
export class AcceptTermsConditionsComponent implements OnInit {
  public iamNotRobotChecked: boolean;
  public termConditionChecked: boolean;
  public requestId: boolean;

  constructor(public translate: TranslateService,
              public activeModal: NgbActiveModal,
              private modalService: NgbModal) {
  }

  ngOnInit(): void {
  }

  public resolved(captchaResponse: string): void {
    if (captchaResponse) {
      this.iamNotRobotChecked = true;
    } else {
      this.iamNotRobotChecked = false;
    }
  }

  public onError(errorDetails: any): void {
    this.iamNotRobotChecked = false;
  }

  accept() {
    if (this.iamNotRobotChecked && this.termConditionChecked) {
      this.activeModal.close(InformType.Success);
    } else {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.RECAPTCHA-REQUIRED'), this.translate.instant('MESSAGE.RECAPTCHA-IMPORTANT-MESSAGE'));
    }
  }

  cancel() {
    this.activeModal.close();
  }

  checked(event: any) {
    if (event.target.checked) {
      this.termConditionChecked = true;
    } else {
      this.termConditionChecked = false;
    }
  }

  openModalPdfViewer4termAndConditions() {
    const url = TermCondition.PATH_FILE.concat('term-and-conditions.pdf');
    const tittle = this.translate.instant('TITLE.TERMS-AND-CONDITIONS');
    this.openModalPdfViewer(url, tittle);
  }

  openModalPdfViewer4CertificateRequest() {
    const url = Constant.ROOT_API_V1.concat('/public/solcert/requests/')
      .concat(String(this.requestId));
    const tittle = this.translate.instant('TITLE.CERTIFICATE-REQUEST');
    this.openModalPdfViewer(url, tittle);
  }

  openModalPdfViewer(url: string, tittle: string) {
    const opemModal = this.modalService.open(TermPdfViewerComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    opemModal.componentInstance.urlStream = url;
    opemModal.componentInstance.title = tittle;
  }
}
